import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from '@bit/knotchinc.web-react-components.box';
import SearchFilter from 'components/Global/Filters/SearchFilter/SearchFilter.jsx';
import FilterSideMenu from '@bit/knotchinc.web-react-components.filter-side-menu';
import { PageBody, PageContent } from '@bit/knotchinc.web-react-components.page';
import AddCompetitorsModal from 'components/Modals/AddCompetitorsModal/AddCompetitorsModal.jsx';
import { ComponentTabContainer, ComponentTab } from '@bit/knotchinc.web-react-components.tabs';
import ListSync from '@bit/knotchinc.web-react-components.list-sync';
import { getCompetitors, SET_USER_COMPETITORS_FILTER } from './actions.js';
import { CompetitorRow } from './rows/CompetitorRow.jsx';
import { AddCompetitorButton } from './styled.js';

export class CompetitorsMgmtView extends Component {
  constructor() {
    super();
    this.state = {
      competitorsModalOpen: false,
    };
  }

  render() {
    const { fetchCompetitors, Settings: { competitorsList } } = this.props;
    const { competitorsModalOpen } = this.state;

    const closeCompetitorsModal = () => this.setState({ competitorsModalOpen: false }, () => fetchCompetitors(true));
    const openCompetitorsModal = () => this.setState({ competitorsModalOpen: true });

    return (
      <PageBody>
        <FilterSideMenu clearAll={() => {}}>
          <SearchFilter filterAction={SET_USER_COMPETITORS_FILTER} searchBy="name" />
        </FilterSideMenu>
        <PageContent>
          <AddCompetitorButton onClick={openCompetitorsModal}>ADD COMPETITORS</AddCompetitorButton>
          <ComponentTabContainer>
            <ComponentTab tabName="competitors" tabMetric={`${competitorsList.data.length} Competitors`}>
              <Box padding="20px">
                <ListSync
                  listStore={competitorsList}
                  fetch={clear => fetchCompetitors(clear)}
                >
                  <CompetitorRow />
                </ListSync>
              </Box>
            </ComponentTab>
          </ComponentTabContainer>
        </PageContent>
        <AddCompetitorsModal isOpen={competitorsModalOpen} close={closeCompetitorsModal} />
      </PageBody>);
  }
}


const mapStateToProps = ({
  Account,
  Settings,
}) => ({ Account, Settings });

const mapDispatchToProps = dispatch => ({
  fetchCompetitors: clear => dispatch(getCompetitors(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompetitorsMgmtView);
